import {
  buildFetchOptionsWithAuth,
  fetchJson,
  flattenPages,
  getNextPageParam,
  useInfiniteQuery,
} from '@fv/client-core'
import type { PagedShipments } from '@fv/client-types'

import { apiUri, defaultPageSize } from '@/constants'

type searchShipmentsArgs = {
  search: string
  skip: number
}

async function searchShipments({
  search,
  skip,
}: searchShipmentsArgs): Promise<PagedShipments> {
  const endpoint = `${apiUri}/shipments/search`
  const options = buildFetchOptionsWithAuth({
    query: {
      limit: defaultPageSize,
      search,
      skip,
    },
  })

  const response = await fetchJson(endpoint, options)
  if (response.ok) return response.json
  throw response.errorMessage
}

export function useSearchShipments(searchText: string | null) {
  const shipmentsQuery = useInfiniteQuery({
    queryKey: ['shipments', 'search', searchText],
    initialPageParam: 0,
    queryFn: ({ pageParam = 0 }) =>
      searchShipments({
        search: searchText ?? '',
        skip: pageParam,
      }),
    enabled: Boolean(searchText),
    getNextPageParam,
  })

  return {
    ...shipmentsQuery,
    data: flattenPages(shipmentsQuery.data?.pages),
  }
}
